<div class="aems-card m-b-12">
  <div class="pure-g">
    <div class="pure-u-md-8-24 pure-u-lg-6-24 p-b-16 p-r-8" style="width: 20%">
      <div>{{ workOrder?.maintenanceOrderNumber }}</div>
      <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Work Order</div>
    </div>
    <div class="pure-u-md-8-24 pure-u-lg-6-24 p-b-16 p-r-8" style="width: 20%">
      <div>{{ workOrder?.vendorsReference ?? '-' }}</div>
      <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Vendor Ref No.</div>
    </div>
    <div class="pure-u-md-8-24 pure-u-lg-6-24 p-b-16 p-r-8" style="width: 20%">
      <div>{{ workOrder?.equipmentNumber }}</div>
      <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Equipment Number</div>
    </div>
    <div class="pure-u-md-8-24 pure-u-lg-6-24 p-b-16 p-r-8" style="width: 30%">
      <div>{{ workOrderStatusDescription }}</div>
      <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Status</div>
    </div>
    <div class="pure-u-md-8-24 pure-u-lg-6-24 p-b-16 p-r-8" style="width: 10%">
      <div>{{ workOrder?.maintenanceRepairModeCode }}</div>
      <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Mode</div>
    </div>
  </div>
</div>

<div class="pure-u-md-24-24 pure-u-lg-24-24">
  <div class="inline m-r-8 m-t-8">
    <mc-switch label="Show system updates" name="isSystemLog" value="isSystemLog" (change)="showSystemUpdate()" fit="small"> </mc-switch>
  </div>
</div>

<div class="table-container m-t-12">
  @if ((auditlogNewApiCallStatus === 'COMPLETED_SUCCESFULLY' && newAuditLogData.length > 0) || auditlogNewApiCallStatus === 'IN_PROGRESS') {
    <div class="pure-g scrollable-table">
      <div class="pure-u-md-5-5">
        <mc-table
          [data]="newAuditLogData.length > 0 ? newAuditLogData : mockDataForLoadingAnimation"
          fit="small"
          [columns]="auditColumns"
          [customstyles]="customTableStyles"
          nowrap="false"
          sortdisabled
          dimension="large">
          @for (row of newAuditLogData; track row; let i = $index) {
            @for (col of auditColumns; track col) {
              @if (col.id !== 'isEmpty') {
                <div slot="{{ col.id }}">
                  {{ getValue(row, col.id) }}
                </div>
              }
            }
          }

          @for (row of mockDataForLoadingAnimation; track $index) {
            @for (item of auditColumns; track $index) {
              <div slot="{{ row.id }}_{{ item.id }}">
                <app-loader></app-loader>
              </div>
            }
          }
        </mc-table>
      </div>
    </div>
  } @else {
    <div class="pure-g">
      <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-204 flex-container flex-center no-data">
        <span i18n>No Data Found</span>
      </div>
    </div>
  }
</div>
@if (newAuditLogData.length > 0) {
  <div class="pure-g m-t-16 footer">
    <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24">
      <mc-select
        style="width: 140px; display: block"
        [value]="pageLimit"
        optionswidth="100px"
        ngDefaultControl
        label="Per page"
        labelposition="left"
        fit="small"
        (optionselected)="onPageLimitChange($event)">
        @for (pageCount of [10, 20, 50, 100, 200]; track $index) {
          <mc-option [value]="pageCount">{{ pageCount }}</mc-option>
        }
      </mc-select>
    </div>

    <div class="pure-u-md-12-24 pure-u-lg-16-24 pure-u-xl-16-24 flex-container flex-center">
      @if (newAuditLogData.length != totalItemCount) {
        <mc-pagination
          hiddenlabels
          [currentpage]="currentPage"
          [totalpages]="lastPage"
          visiblepages="7"
          (pagechange)="onPageChange($event)"
          fit="small">
        </mc-pagination>
      }
    </div>

    <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24 text-align-right">
      <span class="page-description" i18n>Showing {{ newAuditLogData.length }} of {{ totalItemCount }}</span>
    </div>
  </div>
}
